import { render, staticRenderFns } from "./AddFileToLibrary.vue?vue&type=template&id=9901aed6&scoped=true&"
import script from "./AddFileToLibrary.vue?vue&type=script&lang=js&"
export * from "./AddFileToLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9901aed6",
  null
  
)

export default component.exports